import AuthModal from 'components/system/AuthModal/AuthModal';
import { TechnologyLogo } from 'components/system/TechnologyLogo/TechnologyLogo';
import { PropsWithChildren } from 'react';

type SetupAccountModalProps = PropsWithChildren & {
  open: boolean;
  handleBackToLogin: () => void;
};

export const SetupAccountModal = ({
  children,
  handleBackToLogin,
  open,
}: SetupAccountModalProps) => {
  return (
    <AuthModal open={open}>
      <AuthModal.Logo>
        <TechnologyLogo />
      </AuthModal.Logo>
      {children}
      <AuthModal.Links>
        <AuthModal.Link onClick={handleBackToLogin}>
          Back to login
        </AuthModal.Link>
      </AuthModal.Links>
    </AuthModal>
  );
};
